var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    zoomAndPan: "magnify",
    viewBox: "0 0 224.87999 225",
    height: 300,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1908cb7580"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 15 L 209 15 L 209 224.9375 L 9 224.9375 Z M 9 15 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1908cb7580)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 38.371094 109.824219 C 57.113281 128.5625 70.5 147.304688 83.882812 171.398438 C 146.351562 53.601562 222.203125 0.0585938 206.140625 18.800781 C 155.273438 83.945312 120.472656 149.980469 86.5625 224.941406 C 66.929688 189.246094 41.941406 141.949219 11.601562 132.132812 C 2.675781 123.207031 24.09375 101.792969 38.371094 109.824219 Z M 38.371094 109.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkDark);
export default __webpack_public_path__ + "static/media/checkmark-dark.1826eabf0e2181d2f2c88d7b72731149.svg";
export { ForwardRef as ReactComponent };